import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { QrCode } from 'lucide-react';
import { getBearerToken } from '@/context/TrackOticAuthContext';
import { PassportBatchesTable } from '@/pages/admin/qr/PassportBatchesTable';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PassportStockPage() {
  const [stock, setStock] = useState(null);

  useEffect(() => {
    const token = getBearerToken();
    fetch(`${API}/api/qr/stock`, { credentials: 'include', headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(async r => { if (!r.ok) throw new Error((await r.json()).detail || `Request failed (${r.status})`); return r.json(); })
      .then(setStock).catch(e => toast.error(e.message));
  }, []);

  return (
    <div className="p-6 lg:p-8 max-w-6xl space-y-6" data-testid="passport-stock-page">
      <div className="flex items-start gap-3">
        <QrCode className="mt-1" style={{ color: '#0B6B55' }} />
        <div>
          <h1 className="text-3xl font-bold" style={{ color: '#1B1D1C' }}>Passport stock</h1>
          <p className="text-sm mt-1" style={{ color: '#6b7069' }}>Passports issued to you by Track0tic and not yet bound to a device. Print labels at 100% scale.</p>
        </div>
      </div>
      {stock && (
        <>
          <div className="grid sm:grid-cols-3 gap-4">
            <Stat label="ISSUED, in stock" value={stock.issued_total} testId="stock-issued-total" />
            <Stat label="Batches" value={stock.batches.length} testId="stock-batches" />
            <Stat label="Unbatched" value={stock.unbatched_issued} testId="stock-unbatched" />
          </div>
          <PassportBatchesTable batches={stock.batches} tenantScoped />
        </>
      )}
    </div>
  );
}

const Stat = ({ label, value, testId }) => (
  <div className="rounded-lg border bg-white p-5" style={{ borderColor: '#E5E3DC' }} data-testid={testId}>
    <p className="text-sm" style={{ color: '#6b7069' }}>{label}</p>
    <p className="text-3xl font-bold mt-1" style={{ color: '#1B1D1C', fontFamily: "'IBM Plex Mono', monospace" }}>{value}</p>
  </div>
);
